import React, { Component } from "react";
import axios from "axios";
import { BrowserRouter, Route, Navigate } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Panel } from "primereact/panel";

import Server from "./../Server.js";
import { DataView, DataViewLayoutOptions } from "primereact/dataview";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Button } from "reactstrap";
import { AutoComplete } from "primereact/autocomplete";

import { connect } from "react-redux";
import { Dropdown } from "primereact/dropdown";
import { Loader } from "rsuite";
import { Toast } from "primereact/toast";
import { Checkbox } from "primereact/checkbox";
import { MultiSelect } from "primereact/multiselect";

class ShopsList extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();
    this.state = {
      CategoryListForDropDown: [],
      GridDataUsers: [],
      shop_groups: [],
      GridDataFactors: [],
      selectedCommission: null,
      selectedUserId: null,
      selectedMainShop: null,
      selectedRegistrable: null,
      AllowCredit: false,
      showInSite: false,
      selectedName: null,
      parent: null,
      parentId: null,
      selectedAddress: null,
      selectedCall: null,
      selectedMobile: null,
      selectedSheba: null,
      selectedRaymandAcc: null,
      selectedId: null,
      visibleDialog: false,
      statusDesc: null,
      SellerId: null,
      LastAmount: 0,
      loading: true,
      absoluteUrl: this.Server.getAbsoluteUrl(),
      url: this.Server.getUrl(1),
    };
    this.onHide = this.onHide.bind(this);
    this.selectedListChange = this.selectedListChange.bind(this);
    this.EditShopSelected = this.EditShopSelected.bind(this);

    this.FileUpload = this.FileUpload.bind(this);
    this.toast = React.createRef();
  }

  FileUpload(e) {
    e.preventDefault();
    const formData = new FormData();
    let name = e.target.name;
    if (name == "SpecialPic") formData.append("SpecialPic", "1");
    formData.append("myImage", e.target.files[0]);
    if (this.state.selectedId) {
      formData.append("ShopId", this.state.selectedId);
    }
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios({
      url: `${this.state.url}uploadFile`,
      data: formData,
      method: "post",
      config,
    })
      .then((response) => {
        if (name == "file")
          this.setState({
            logo: this.state.absoluteUrl + response.data.split("public")[1],
          });
        if (name == "SpecialPic")
          this.setState({
            SpecialPic:
              this.state.absoluteUrl + response.data.split("public")[1],
          });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  CatTOptionTemplate(option) {
    return (
      <div className="country-item">
        <div>{option.name}</div>
      </div>
    );
  }

  onSelect(event) {
    this.setState({
      selectedName: event.value.name,
      selectedShopId: event.value._id,
    },()=>{
      this.onHide();
    });
  }
  onSelect2(event) {
    this.setState({
      selectedUser: event.value.name,
      selectedUserId: event.value._id,
    });
  }
  onSelect3(event) {
    this.setState({ parent: event.value.name, parentId: event.value._id });
  }
  suggestBrands(event) {
    let that = this;
    this.setState({ brand: event.query, Count: 0 });
    let param = {};
    if (this.state.user == 1) {
      param = {
        title: event.query,
        table: "users",
        name: ["name", "username"],
      };
    } else {
      param = {
        title: event.query,
        table: "shops",
        name: ["name", "name"],
      };
    }

    let SCallBack = function (response) {
      let brandSuggestions = [];
      response.data.result.reverse().map(function (v, i) {
        brandSuggestions.push({
          _id: v._id,
          name: v.name,
          username: v.username,
        });
      });
      that.setState({ brandSuggestions: brandSuggestions });
    };

    let ECallBack = function (error) {};
    that.Server.send("AdminApi/searchItems", param, SCallBack, ECallBack);
  }
  itemTemplate(brand) {
    return (
      <div
        className="p-clearfix"
        style={{ direction: "rtl", maxWidth: "100%" }}
      >
        <div
          style={{ margin: "10px 10px 0 0" }}
          className="row"
          _id={brand._id}
        >
          <div className="col-8" _id={brand._id} style={{ textAlign: "right" }}>
            <span
              className="iranyekanwebregular"
              style={{ textAlign: "right", overflow: "hidden" }}
              _id={brand._id}
            >
              <span style={{ whiteSpace: "pre-wrap" }} _id={brand._id}>
                {brand.name} ({brand.username})
              </span>
              <br />
            </span>
          </div>
        </div>
      </div>
    );
  }

  selectedCatTemplate(option, props) {
    if (option) {
      return (
        <div className="country-item country-item-value">
          <div>{option.name}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  }
  componentDidMount() {
    if (window.innerWidth <= 768) {
      this.setState({
        isMobile: true,
      });
    }
    let param = {
      token: localStorage.getItem("api_token"),
    };
    let that = this;
    let SCallBack = function (response) {
      that.setState({
        SellerId: response.data.authData.UserId,
      },()=>{
        that.GetShopList();
      });
      
    };
    let ECallBack = function (error) {
      that.setState({
        loading: false,
      });
      console.log(error);
    };
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack);
  }

  onHide(event) {
    this.setState({
      selectedId: null,
      selectedName: null,
      parent: null,
      selectedAddress: null,
      selectedCall: null,
      selectedMobile: null,
      selectedSheba: null,
      selectedRaymandAcc: null,
      selectedCommission: null,
      selectedUserId: null,
      selectedUser: null,
      selectedMainShop: null,
      selectedRegistrable: null,
      AllowCredit: false,
      showInSite: false,
      paymentType: "",
      paymentMounth: "",
      MehrCommission: 0,
      visibleDialog: false,
      Opened: false,
      SpecialPic: null,
      logo: null,
      loading: true
    },()=>{
      this.GetShopList();
    });
  }
  selectedListChange(value) {
    let that = this;
    this.setState({
      visibleDialog: true,
      selectedId: value._id,
      selectedCommission: value.commission,
      selectedUserId: value.users[0] ? value.users[0]._id : null,
      selectedUser: value.users[0] ? value.users[0].name : null,
      selectedMainShop: value.main,
      selectedRegistrable: value.Registerable,
      AllowCredit: value.AllowCredit,
      showInSite: value.showInSite,
      paymentType: value.paymentType,
      paymentMounth: value.paymentMounth,
      shopGroup: value.shopGroup,
      MehrCommission: value.MehrCommission || 0,
      selectedName: value.name,
      parentId: value.parentId,
      parent: value.parentShop[0] ? value.parentShop[0].name : null,
      selectedAddress: value.address,
      selectedCall: value.call || "",
      selectedMobile: value.mobile || "",
      selectedSheba: value.Sheba || "",
      selectedRaymandAcc: value.RaymandAcc || "",
      logo: value.logo
        ? that.state.absoluteUrl + value.logo.split("public")[1]
        : "http://siteapi.ansar724.com/nophoto.png",
      SpecialPic: value.SpecialPic
        ? that.state.absoluteUrl + value.SpecialPic.split("public")[1]
        : "http://siteapi.ansar724.com/nophoto.png",
    });
  }

  GetShopList(All) {
    let that = this;
    let param = {
      ShopId: !All ? this.state.selectedShopId : null,
    };
    let SCallBack = function (response) {
      that.setState({
        GridDataFactors: response.data.result,
      });
      that.GetCategory();
    };
    let ECallBack = function (error) {
      that.GetCategory();
      console.log(error);
    };
    this.Server.send("AdminApi/ShopInformation", param, SCallBack, ECallBack);
  }

  EditShopSelected() {
    let that = this;
    /*if (
      !this.state.selectedUserId &&
      this.state.selectedUser &&
      !this.state.selectedMobile
    ) {
      that.toast.current.show({
        severity: "error",
        summary: "خطای سرور",
        detail: "شماره تلفن همراه را وارد کنید",
        life: 5000,
      });
      return;
    }*/
    let param = {
      token: localStorage.getItem("api_token"),
      address: this.state.selectedAddress,
      showInSite: this.state.showInSite,
      call: this.state.selectedCall,
      mobile: this.state.selectedMobile,
      User_Name: this.state.selectedUser,
      Sheba: this.state.selectedSheba,
      RaymandAcc: this.state.selectedRaymandAcc,
      ShopId: this.state.selectedId,
      name: this.state.selectedName,
      parent: this.state.parent,
      parentId: this.state.parentId,
      commission: this.state.selectedCommission,
      UserId: this.state.selectedUserId,
      main: this.state.selectedMainShop,
      Registerable: this.state.selectedRegistrable,
      AllowCredit: this.state.AllowCredit,
      paymentType: this.state.paymentType,
      paymentMounth: this.state.paymentMounth,
      shopGroup: this.state.shopGroup,
      MehrCommission: parseInt(this.state.MehrCommission || 0),
      edit: "1",
      editByAdmin: "1",
      logo: this.state.logo,
      SpecialPic: this.state.SpecialPic
    };
    that.setState({
      loading: true,
    });
    let SCallBack = function (response) {
      that.onHide();
      that.toast.current.show({
        severity: "success",
        summary: "",
        detail: "عملیات با موفقیت انجام شد",
        life: 3000,
      });
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: false,
      });
      that.toast.current.show({
        severity: "error",
        summary: "خطای سرور",
        detail: "عملیات انجام نشد",
        life: 3000,
      });
    };
    this.Server.send("AdminApi/ShopInformation", param, SCallBack, ECallBack);
  }
  GetCategory() {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      SellerId: this.state.SellerId,
    };
    let SCallBack = function (response) {
      let CatList = [];
      for (let i = 0; i < response.data.result.length; i++) {
        CatList.push({
          name: response.data.result[i].name,
          value: response.data.result[i]._id,
        });
      }
      that.setState({
        CategoryListForDropDown: CatList,
      },()=>{
        that.GetShopGroups();
      });
      
    };
    let ECallBack = function (error) {
      that.toast.current.show({
        severity: "error",
        summary: "خطای سرور",
        detail: "عملیات انجام نشد",
        life: 3000,
      });
      that.setState({
        loading: 0,
      });
    };
    this.Server.send("AdminApi/GetCategory", param, SCallBack, ECallBack);
  }
  GetShopGroups() {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
    };
    let SCallBack = function (response) {
      that.setState({
        shop_groups: response.data.result,
        shopGroup: response.data.result[0]
          ? response.data.result[0]?._id
          : null,
        loading: false,
      });
    };
    let ECallBack = function (error) {
      that.toast.current.show({
        severity: "error",
        summary: "خطای سرور",
        detail: "عملیات انجام نشد",
        life: 3000,
      });
      that.setState({
        loading: false,
      });
    };
    this.Server.send("AdminApi/getShopGroup", param, SCallBack, ECallBack);
  }
  rowClass(data) {
    if (data.users[0]){
      data.Seller = data.users[0].name;
    }else{
      data.Seller = "-";

    }
    if (data.AllowCredit) data.InMehrCart = <i className="fas fa-check"></i>;
    if (data && data.parentShop && data.parentShop[0]){
      data.parent = data.parentShop[0].name;
    }else{
      data.parent = "-"
    }
    return {
      "row-highlight1": 0,
    };
  }

  selectedTemplate = (option, props) => {
    if (option) {
      return (
        <div className="country-item country-item-value">
          <div>{option.name}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  render() {
    return (
      <div style={{ direction: "rtl" }}>
        
        <Toast
          ref={this.toast}
          position="top-left"
          style={{ fontFamily: "YekanBakhFaBold", textAlign: "right" }}
        />
        <div className="row justify-content-center mt-2">
          <div className=" col-12" style={{ background: "#fff" }}>
          <div className="row mt-5">
                <div className="col-12">
                  <button
                    className="btn btn-info irsans"
                    onClick={() => this.setState({ visibleDialog: true })}
                    style={{ width: "200px", marginBottom: "20px" }}
                  >
                    ایجاد /جستجوی فروشگاه
                  </button>
                </div>
              </div>
            <div className="section-title " style={{ textAlign: "right" }}>
              <span
                className="title IRANYekan"
                style={{ fontSize: 17, color: "gray" }}
              >
                لیست فروشگاهها
              </span>
            </div>
            
            
            <DataTable
              resizableColumns={true}
              rowClassName={this.rowClass}
              paginator={true}
              rows={10}
              value={this.state.GridDataFactors}
              selectionMode="single"
              selection={this.state.selectedId}
              onSelectionChange={(e) => this.selectedListChange(e.value)}
              loading={this.state.loading}
            >
              <Column
                field="name"
                header="نام فروشگاه"
                className="yekan"
                style={{ textAlign: "right" }}
              />
              <Column
                field="Seller"
                header="مدیر فروشگاه"
                className="yekan"
                style={{ textAlign: "right" }}
              />
              <Column
                field="parent"
                header="شعبه مرکزی"
                className="yekan"
                style={{
                  textAlign: "right",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                }}
              />
              <Column
                field="InMehrCart"
                header="متصل به فروش اقساطی"
                className="yekan"
                style={{ textAlign: "center", width: 80  }}
              />
            </DataTable>
            
          </div>
        </div>

        <Dialog
          header="مشخصات فروشگاه"
          visible={this.state.visibleDialog}
          style={{ width: "60vw" }}
          minY={70}
          onHide={this.onHide}
          maximized={this.state.isMobile ? true : false}
          maximizable={true}
        >
          <form>
            <div className="row">
              <div className="col-lg-6">
                <div className="group">
                  <AutoComplete
                    placeholder="نام فروشگاه"
                    style={{ width: "100%" }}
                    onChange={(event) => {
                      this.setState({
                        selectedName: event.value,
                        user: 0,
                        selectedShopId: null,
                      });
                    }}
                    itemTemplate={this.itemTemplate.bind(this)}
                    value={this.state.selectedName}
                    onSelect={(e) => this.onSelect(e)}
                    suggestions={this.state.brandSuggestions}
                    completeMethod={this.suggestBrands.bind(this)}
                  />
                </div>
              </div>
              <div className="col-lg-6 mt-2">
                  <label class="yekan" style={{marginRight:7}} >مدیر / کارمند</label>

                <div>
                  <AutoComplete
                    style={{ width: "100%" }}
                    onChange={(event) => {
                      this.setState({
                        selectedUser: event.value,
                        user: 1,
                        selectedUserId: null,
                      });
                    }}
                    itemTemplate={this.itemTemplate.bind(this)}
                    value={this.state.selectedUser}
                    onSelect={(e) => this.onSelect2(e)}
                    suggestions={this.state.brandSuggestions}
                    completeMethod={this.suggestBrands.bind(this)}
                  />
                </div>
              </div>
              <div className="col-lg-12" style={{ marginTop: 10 }}>
                <div>
                  <label className="yekan labelNoGroup">گروه فروشگاهی</label>
                  <Dropdown
                    value={this.state.shopGroup}
                    panelStyle={{ textAlign: "right" }}
                    style={{
                      fontFamily: "iranyekanwebregular",
                      width: "99.5%",
                      textAlign: "right",
                    }}
                    options={this.state.shop_groups}
                    onChange={(event) =>
                      this.setState({
                        shopGroup: event.target.value,
                      })
                    }
                    optionLabel="name"
                    optionValue="_id"
                    placeholder="فروشگاه را انتخاب کنید"
                    valueTemplate={this.selectedTemplate}
                    filter
                    filterBy="name"
                    itemTemplate={this.ShopOptionTemplate}
                  />
                </div>
              </div>

              <div className="col-lg-12">
                <div className="group">
                  <textarea
                    className="form-control yekan"
                    autoComplete="off"
                    type="text"
                    value={this.state.selectedAddress}
                    name="selectedAddress"
                    onChange={(event) =>
                      this.setState({ selectedAddress: event.target.value })
                    }
                    required="true"
                  />
                  <label className="yekan">آدرس</label>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="group">
                  <textarea
                    className="form-control yekan"
                    autoComplete="off"
                    type="text"
                    value={this.state.selectedCall}
                    name="selectedCall"
                    onChange={(event) =>
                      this.setState({ selectedCall: event.target.value })
                    }
                    required="true"
                  />
                  <label className="yekan">اطلاعات تماس</label>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="group">
                  <textarea
                    className="form-control yekan"
                    autoComplete="off"
                    type="text"
                    value={this.state.selectedMobile}
                    name="selectedMobile"
                    onChange={(event) =>
                      this.setState({ selectedMobile: event.target.value })
                    }
                    required="true"
                  />
                  <label className="yekan">
                    شماره تلفن همراه - جهت دریافت پیامک{" "}
                  </label>
                </div>
              </div>

              <div
                className="col-lg-12"
                style={{ marginTop: 10, marginBottom: 10 }}
              >
                <div
                  style={{
                    paddingRight: 8,
                    textAlign: "right",
                    display: "flex",
                  }}
                >
                  <Checkbox
                    inputId="laon"
                    value={this.state.AllowCredit}
                    checked={this.state.AllowCredit}
                    onChange={(e) => this.setState({ AllowCredit: e.checked })}
                  ></Checkbox>
                  <label
                    htmlFor="laon"
                    className="p-checkbox-label yekan"
                    style={{ paddingRight: 5 }}
                  >
                    متصل به کیف پول{" "}
                  </label>
                </div>
              </div>

              {this.state.AllowCredit && (
                <div className="col-lg-3 col-12">
                  <div className="group">
                    <input
                      className="form-control yekan"
                      autoComplete="off"
                      type="text"
                      value={this.state.MehrCommission}
                      name="MehrCommission"
                      onChange={(event) =>
                        this.setState({ MehrCommission: event.target.value })
                      }
                      required="true"
                    />
                    <label className="yekan">کارمزد خرید اقساطی</label>
                  </div>
                </div>
              )}
              {this.state.AllowCredit && (
                <div className="col-lg-3 col-12">
                  <div className="group">
                    <select
                      value={this.state.paymentMounth}
                      style={{ width: "100%" }}
                      onChange={(event) =>
                        this.setState({
                          paymentMounth: event.target.value,
                        })
                      }
                    >
                      <option value="">تعداد ماه تسویه</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </select>
                  </div>
                </div>
              )}
              {this.state.AllowCredit && (
                <div className="col-lg-6 col-12">
                  <div className="group">
                    <input
                      className="form-control yekan"
                      autoComplete="off"
                      type="text"
                      value={this.state.paymentType}
                      name="paymentType"
                      onChange={(event) =>
                        this.setState({ paymentType: event.target.value })
                      }
                      required="true"
                    />
                    <label className="yekan">توضیح تسویه</label>
                  </div>
                </div>
              )}

              {this.state.AllowCredit && (
                <div className="col-lg-6 mt-2">
                  <label class="yekan" style={{marginRight:7}} >شعبه مرکزی</label>

                  <div>
                    <AutoComplete
                      style={{ width: "100%" }}
                      onSelect={(e) => this.onSelect3(e)}
                      onChange={(event) => {
                        this.setState({
                          user: 0,
                          parent: event.value,
                          parentId: null,
                        });
                      }}
                      itemTemplate={this.itemTemplate.bind(this)}
                      value={this.state.parent}
                      suggestions={this.state.brandSuggestions}
                      completeMethod={this.suggestBrands.bind(this)}
                    />
                  </div>
                </div>
              )}

              <div
                className="col-lg-12"
                style={{ marginTop: 10, marginBottom: 10, display: "none" }}
              >
                <div
                  style={{
                    paddingRight: 8,
                    textAlign: "right",
                    display: "flex",
                  }}
                >
                  <Checkbox
                    inputId="laon"
                    value={this.state.selectedMainShop}
                    disabled={true}
                    checked={this.state.selectedMainShop}
                    onChange={(e) =>
                      this.setState({ selectedMainShop: e.checked })
                    }
                  ></Checkbox>
                  <label
                    htmlFor="laon"
                    className="p-checkbox-label yekan"
                    style={{ paddingRight: 5 }}
                  >
                    فروشگاه اصلی
                  </label>
                </div>
              </div>

              {this.state.selectedId && (
                <Panel
                  header="مدیریت لوگو و تصاویر"
                  style={{
                    textAlign: "right",
                    fontFamily: "yekan",
                    marginBottom: 30,
                    marginTop: 30,
                  }}
                  toggleable={true}
                  collapsed={true}
                >
                  <div className="row">
                    <div className="col-md-6 col-12" style={{ marginTop: 20 }}>
                      <div className="group">
                        <input
                          className="form-control yekan"
                          autoComplete="off"
                          onChange={this.FileUpload}
                          type="file"
                          name="file"
                        />
                        <label>آپلود لوگو</label>
                      </div>
                    </div>
                    <div className="col-md-6 col-12" style={{ marginTop: 20 }}>
                      <img src={this.state.logo} style={{ maxHeight: 150 }} />
                    </div>

                    <div className="col-md-6 col-12" style={{ marginTop: 20 }}>
                      <div className="group">
                        <input
                          className="form-control yekan"
                          autoComplete="off"
                          onChange={this.FileUpload}
                          type="file"
                          name="SpecialPic"
                        />
                        <label> آپلود تصویر اختصاصی</label>
                      </div>
                    </div>
                    <div className="col-md-6 col-12" style={{ marginTop: 20 }}>
                      <img
                        src={this.state.SpecialPic}
                        style={{ maxHeight: 150 }}
                      />
                    </div>
                  </div>
                </Panel>
              )}

              <div className="col-lg-12">
                <Button
                  style={{ marginLeft: 5, marginTop: 10 }}
                  color="primary"
                  className="yekan"
                  onClick={this.EditShopSelected}
                >
                  ثبت اطلاعات
                </Button>
              </div>
            </div>
          </form>
        </Dialog>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(ShopsList);
